import { SetPasswordCard } from "@/components/SetPasswordCard";
import { useAuth } from "@/auth/AuthContext";

export function AcceptInvitePage() {
  const { acceptInvite } = useAuth();

  return (
    <SetPasswordCard
      title="Set your password"
      subtitle="Choose a password to finish creating your Summit account."
      submitLabel="Set password and sign in"
      invalidLinkMessage="This invitation link is missing its token. Check the link in your email, or ask an administrator to resend it."
      genericErrorMessage="Could not accept the invitation."
      onSubmit={acceptInvite}
    />
  );
}
